import React, { Component } from 'react'
import styles from './style.module.less'
import { observer, inject } from 'mobx-react'
import CaseEditor from '../../SessionCase/CaseEditor'

@inject('sessionCaseStore')
@observer
export default class extends Component {
  render() {
    return (
      <div className={styles.wrapper}>
        <CaseEditor store={this.props.sessionCaseStore} />
      </div>
    )
  }
}
